import { ProjectId } from 'api/models';

export const getProjectMembersExclusionQueryKey = ([, projectId]: ProjectId): [
  string,
  number,
] => ['project-members-exclusion', projectId];
